<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Generieren...</h4>
</div>
<div class="modal-body" style="
    max-height: Calc(90vh - 50px);
">
  @if(IsCalculating())
  {
    <h5 style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">Generiere für: {{CalculationPartner()?.name}} ({{CalculationPartner()?.ik}})</h5>
    <p>
      Monat: <strong>{{CalculationMonth()}}/{{CalculationYear()}}</strong> <br />
      Prüfe Eintrag {{AktuellerEintrag()}} von {{AnzahlEintraege()}} Prozent ({{CalculatePercentage() | number: '1.0-0'}} %)
    </p>
  }

  @if(ShowErrorInfo())
  {
    <div class="alert alert-danger" role="alert">
      Einzele einträge konnten nicht generiert werden! Versuchen sie es Später erneut!
    </div>
  }

  @if(Success())
  {
    <h3 class="alert alert-success" role="alert">Generierung Abgeschlossen</h3>
    @if(Lauf().length == 0)
    {
      <div class="alert alert-info" role="alert">
       Keine neuen Einträge wurden Genneriert.
      </div>
    }
  }

  @if(Lauf().length > 0)
  {
    @if(Lauf().filter(o => o.missingInbts.length > 0).length > 0)
    {
      <div class="alert alert-danger" role="alert">
        Einzelne Inbetriebnahme Dateien fehlen! Bitte pflegen sie diese nach.
      </div>
      <strong>Volgende Aufträge müssen Kontroliert Werden:</strong>
      <p>
        {{Lauf().flatMap(o => o.missingInbts).join(', ')}}
      </p>
    }
  }

  @if(CanClose())
  {
      <div class="btn btn-primary w-100" (click)="modal.dismiss('Cross click')">OK</div>
  }

</div>
